const parseBooleanEnv = (value: string | undefined, fallback = false) => {
  if (value == null) return fallback

  const normalized = value.trim().toLowerCase()
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true
  if (['0', 'false', 'no', 'off', ''].includes(normalized)) return false
  return fallback
}

export const config = {
  disableControlLocate: parseBooleanEnv(process.env.REACT_APP_DISABLE_CONTROL_LOCATE),
  shouldSkipAuth: parseBooleanEnv(process.env.REACT_APP_SKIP_AUTH),
  enableCloudWindTransform: parseBooleanEnv(process.env.REACT_APP_ENABLE_CLOUD_WIND_TRANSFORM),
}